'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

/**
 * Root Page - Smart Redirect
 *
 * Checks authentication and redirects users intelligently:
 * - Super Admin → /super-admin/dashboard
 * - Authenticated Users → /dashboard
 * - Unauthenticated → /login
 */
export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    // Check authentication tokens
    const superAdminToken = localStorage.getItem('super_admin_token');
    const accessToken = localStorage.getItem('access_token');
    const userType = localStorage.getItem('user_type');

    // Super admin gets their dedicated dashboard
    if (superAdminToken && userType === 'super_admin') {
      router.replace('/super-admin/dashboard');
      return;
    }

    // Regular authenticated users go to unified dashboard
    if (accessToken) {
      router.replace('/dashboard');
      return;
    }

    // Unauthenticated users go to login
    router.replace('/login');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array - run once on mount only

  // Show loading state while checking auth
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-primary-100">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mb-4"></div>
        <p className="text-gray-600">Loading...</p>
      </div>
    </div>
  );
}
